import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { RESTService } from './rest.service';
import { StorageService } from './storage.service';
import { IUserRole } from 'src/app/shared/interface/userRole.interface';

@Injectable({
  providedIn: 'root'
})

/** This class handles the server communication and application storage for the userRole objects */
export class UserRoleService {

  constructor(private _storage: StorageService, private _rest: RESTService) { }

  /**
   * The function returns all user roles.
   * @returns Observable
   */
  getAll() {
    return this._rest.get('users/roles');
  }

  /**
   * The function returns all user roles.
   * @returns Observable
   */
  getByCompanyId(id: number) {
    return this._rest.get('users/roles/company/' + id);
  }

  /**
   * The function returns all user roles.
   * @returns Observable
   */
  getLocksByCompanyId(id: number) {
    return this._rest.get('users/roles/locks/company/' + id);
  }

  /**
   * The function returns a specific user role by its id  with a GET request
   * @param {number} id
   * @returns Observable
   */
  getById(id: number) {
    return this._rest.get('users/roles/' + id).pipe(map((result) => {
      let userRole = result.data;
      return userRole;
    }));
  }

  /**
   * The function updates a specific user role with a PUT request
   * @param {IUserRole} userRole
   * @returns Observable
   */
  update(userRole: IUserRole) {
    return this._rest.put('users/roles', {userRole: userRole});
  }

  /**
   * The function creates a new user role with a POST request
   * @param {IUserRole} userRole
   * @returns Observable
   */
  create(userRole: IUserRole) {
    return this._rest.post('users/roles', {userRole: userRole});
  }

  /**
   * The function deletes a specific user role  by its id with a DELETE request
   * @param {number} id
   * @returns Observable
   */
  delete(id: number) {
    return this._rest.delete('users/roles/' + id);
  }

}
